/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Note_Related_OrderInputs */

const vi_packaging_note_related_order = /** @type {(inputs: Packaging_Note_Related_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng liên quan`)
};

/**

* @param {Packaging_Note_Related_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_note_related_order = /** @type {((inputs?: Packaging_Note_Related_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Note_Related_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_note_related_order(inputs)
});